/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserPermissionsValidationError,
    UserPermissionsValidationErrorFromJSON,
    UserPermissionsValidationErrorFromJSONTyped,
    UserPermissionsValidationErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPermissionsValidationErrors
 */
export interface UserPermissionsValidationErrors {
    /**
     * 
     * @type {Array<UserPermissionsValidationError>}
     * @memberof UserPermissionsValidationErrors
     */
    readonly errors?: Array<UserPermissionsValidationError> | null;
}

export function UserPermissionsValidationErrorsFromJSON(json: any): UserPermissionsValidationErrors {
    return UserPermissionsValidationErrorsFromJSONTyped(json, false);
}

export function UserPermissionsValidationErrorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsValidationErrors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(UserPermissionsValidationErrorFromJSON)),
    };
}

export function UserPermissionsValidationErrorsToJSON(value?: UserPermissionsValidationErrors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


